module.exports = __webpack_public_path__ + "static/media/NFSB07.ea7d6e0c.jpg";